import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Divider, Grid } from 'semantic-ui-react'
import FormEntry from '../../../models/FormEntry'
import Checkbox from './Checkbox'
import { observer } from 'mobx-react'

@observer
class Section extends Component {
  static propTypes = {
    children: PropTypes.any,
    ignore: PropTypes.any,
    title: PropTypes.element,
    label: PropTypes.string,
    secondaryField: PropTypes.element,
    name: PropTypes.string,
    useDivider: PropTypes.bool,
    equipment: PropTypes.instanceOf(FormEntry)
  }

  static defaultProps = {
    useDivider: true,
    label: 'Non applicable'
  }

  render () {
    const { children, title, name, equipment, secondaryField, useDivider, ignore, label } = this.props

    return (
      <>
        <Grid>
          <Grid.Row stretched>
            <Grid.Column width='10'>
              {title}
            </Grid.Column>
            <Grid.Column width='6' textAlign='right'>
              {!!name && <Checkbox name={name} formEntry={equipment} label={label} />}
              {secondaryField}
            </Grid.Column>
          </Grid.Row>
          {!!ignore && (
            <Grid.Row>
              <Grid.Column width='16'>
                {ignore}
              </Grid.Column>
            </Grid.Row>
          )}
          {!!name && !equipment.getValue(name, false, false) &&
            <Grid.Row>
              <Grid.Column width='16'>
                {children}
              </Grid.Column>
            </Grid.Row>}
          {!name && (
            <Grid.Row>
              <Grid.Column width='16'>
                {children}
              </Grid.Column>
            </Grid.Row>)}
        </Grid>
        {useDivider && <Divider className='thick' />}
      </>
    )
  }
}

export default Section
